import React from 'react';
import PropTypes from 'prop-types';
import { MdClose } from 'react-icons/md';
import { MOBILE_REFINEMENT_TITLE } from '../constants';
const CloseMobileForm = ({
  handleClose
}) => /*#__PURE__*/React.createElement("div", {
  className: "filter__header filter__header--mobile"
}, /*#__PURE__*/React.createElement("p", null, MOBILE_REFINEMENT_TITLE), /*#__PURE__*/React.createElement("i", {
  role: "button",
  onClick: handleClose,
  "aria-label": "Close"
}, /*#__PURE__*/React.createElement(MdClose, null)));
CloseMobileForm.propTypes = {
  handleClose: PropTypes.func.isRequired
};
export default CloseMobileForm;
//# sourceMappingURL=CloseMobileForm.js.map